module.exports = {
      id: "environment-usage",
      viewBox: "0 0 28.781 28.787",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#environment",
      toString: function () {
        return this.url;
      }
    }